import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from "@cinch-labs/design-system";
import classnames from "classnames";
import React, { useState } from "react";
import styles from "./accordion.module.css";
import AccordionButton from "./button.component";
import AccordionContent from "./content.component";
var renderContent = function(text) {
    return /*#__PURE__*/ _jsx(Text, {
        fontSize: "xs",
        fontWeight: "medium",
        children: text
    });
};
export var accordionClassName = "accordionItemContainer";
// Accordion resource - https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/accordion.html
var AccordionItem = function(param, ref) {
    var title = param.title, children = param.children, id = param.id, totalItems = param.totalItems, setCurrentFocusAccordion = param.setCurrentFocusAccordion, sectionId = param.sectionId, buttonId = param.buttonId, onToggleExpanded = param.onToggleExpanded, iconType = param.iconType, iconGradient = param.iconGradient, theme = param.theme;
    var _$ref = useState(false), isExpanded = _$ref[0], setExpanded = _$ref[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var content = typeof children === "string" ? function() {
        return renderContent(children);
    } : children;
    return /*#__PURE__*/ _jsxs("div", {
        className: classnames(styles[accordionClassName], styles["".concat(accordionClassName, "__").concat(theme)]),
        children: [
            /*#__PURE__*/ _jsx(AccordionButton, {
                isExpanded: isExpanded,
                toggleExpanded: function() {
                    var newState = !isExpanded;
                    onToggleExpanded(newState);
                    setExpanded(newState);
                },
                setFocusActive: setCurrentFocusAccordion,
                id: id,
                ref: ref,
                buttonText: title,
                totalItems: totalItems,
                buttonId: buttonId,
                sectionId: sectionId,
                iconType: iconType,
                iconGradient: iconGradient
            }),
            /*#__PURE__*/ _jsx(AccordionContent, {
                isExpanded: isExpanded,
                id: id,
                buttonId: buttonId,
                sectionId: sectionId,
                content: content
            })
        ]
    });
};
export default /*#__PURE__*/ React.forwardRef(AccordionItem);
